import { Injectable } from '@angular/core';
import { BOBCAT_API } from '../common/utils/api.bobcat';
import { HttpService } from '../common/utils/http.service';
import { Societe, Signataire } from '../models/societe';
import 'rxjs/add/operator/map';
import { Observable } from 'rxjs/Observable';
import { Response, URLSearchParams } from '@angular/http';
import { StateService } from './state/state.service';

import { Store } from '@ngrx/store';
import * as fromRoot from '../common/appstore/index';
import * as layout from '../common/appstore/actions';

export interface IstatutSociete {
  statut: any[]
}

@Injectable()
export class SocieteService {

  societe: any;
  signataire: Signataire;
  allsociete: Societe[] = [];

  constructor(
    private httpservice: HttpService,
    private servicestate: StateService,
    private store: Store<fromRoot.AppState>
  ) { }

  saveSociete(societe: Societe, signataire: Signataire, document: any) {
    let newsociete = JSON.stringify(societe);
    let currentdoc = JSON.stringify(document);
    let newsignataire = JSON.stringify(signataire);
    let params = {
      'societe': newsociete,
      'currentdoc': currentdoc,
      'signataire': newsignataire
    }

    this.httpservice
      .post(BOBCAT_API.SAVE_SOCIETE, params)
      .subscribe((societe: Societe) => {
        console.log(societe);
        this.store.dispatch(new layout.AddSociete(societe));
        console.log('save : ' + societe.signataire);
        this.store.dispatch(new layout.AddSignataire(societe.signataire));
        this.societe = societe;
      });
  }

  updateSociete(societe: Societe, signataire: Signataire, document: any) {
    let newsociete = JSON.stringify(societe);
    let currentdoc = JSON.stringify(document);
    let newsignataire = JSON.stringify(signataire);
    let params = {
      'societe': newsociete,
      'currentdoc': currentdoc,
      'signataire': newsignataire
    }
    this.httpservice
      .post(BOBCAT_API.UPDATE_SOCIETE, params)
      .subscribe((societe: Societe) => {
        this.store.dispatch(new layout.AddSociete(societe));
        this.store.dispatch(new layout.AddSignataire(societe.signataire));
        this.societe = societe;
      });
  }

  getAllSociete() {
    return this.httpservice.get(BOBCAT_API.ALL_SOCIETE).map((societes: any) => {
      return this.allsociete = societes;
    });
  }

}



// WEBPACK FOOTER //
// C:/Users/Quentin/projets/kontractor/src/app/services/societe.service.ts